// extracted by mini-css-extract-plugin
module.exports = {"actions":"Table_actions__1V43O","colMaxWidth":"Table_colMaxWidth__gznEQ"};